import React from 'react';
import SectionPaths from 'Components/PickSeatManually/SectionOverview/SectionPaths';
import SectionText from 'Components/PickSeatManually/SectionOverview/SectionText';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  isMobile: boolean;
  sections: Julius.Website.SectionViewModel[];
  onSectionClick: (id: number) => void;
  scale?: number;
  selectedInnerSection?: number;
}

class SectionOverview extends React.PureComponent<IProps> {
  static defaultProps = {
    scale: 1,
  };

  getMinY = (sections: Julius.Website.SectionViewModel[]) => {
    return sections.reduce((totalMin, section) => {
      const sectionMin = section.points.reduce((min, point) => point.y < min ? point.y : min, section.points[0].y);
      return sectionMin < totalMin ? sectionMin : totalMin;
    }, sections[0].points[0].y);
  }

  getMinX = (sections: Julius.Website.SectionViewModel[]) => {
    return sections.reduce((totalMin, section) => {
      const sectionMin = section.points.reduce((min, point) => point.x < min ? point.x : min, section.points[0].x);
      return sectionMin < totalMin ? sectionMin : totalMin;
    }, sections[0].points[0].x);
  }

  getMaxY = (sections: Julius.Website.SectionViewModel[]) => {
    return sections.reduce((totalMax, section) => {
      const sectionMin = section.points.reduce((max, point) => point.y > max ? point.y : max, section.points[0].y);
      return sectionMin > totalMax ? sectionMin : totalMax;
    }, sections[0].points[0].y);
  }

  getMaxX = (sections: Julius.Website.SectionViewModel[]) => {
    return sections.reduce((totalMax, section) => {
      const sectionMin = section.points.reduce((max, point) => point.x > max ? point.x : max, section.points[0].x);
      return sectionMin > totalMax ? sectionMin : totalMax;
    }, sections[0].points[0].x);
  }

  isSelected = (innerSectionID: number): boolean => {
    return innerSectionID === this.props.selectedInnerSection;
  }

  getDimensions = () => {
    const { scale, isMobile, sections } = this.props;
    const sidePadding = `${ isMobile ? 20 : 100 * scale }px`;

    const svgWidth = this.getMaxX(sections);
    const svgHeight = this.getMaxY(sections);
    const svgPadding = `0 ${ sidePadding } 40px ${ sidePadding }`;
    const svgFontSize = `${ svgWidth / (scale / scale * 25) }px`;
    const containerWidth = `${ 100 * scale }%`;
    const containerHeight = '100%';

    return { 
      svgWidth, 
      svgHeight, 
      svgPadding, 
      svgFontSize, 
      containerWidth, 
      containerHeight,
    };
  }
  
  render() {

    if (!this.props.sections) {
      return null;
    }

    const dim = this.getDimensions();
    const { sections, onSectionClick } = this.props;

    const svgWidth = this.getMaxX(sections) - this.getMinX(sections);

    const maxSectionsWithText = 6;

    return (
      <>
        { !this.props.selectedInnerSection && 
          <FormattedText 
            style='title'
            displayName='Klicka på en sektion för att börja välja biljetter.'
            formattedName='section.overview.description'
          /> 
        }
        <svg 
          width={ dim.containerWidth }
          height={ dim.containerHeight }
          viewBox={ `0, 0, ${ dim.svgWidth }, ${ dim.svgHeight }` } 
          style={ { padding: dim.svgPadding } }
        >
          { sections.map((s, i) =>
            <SectionPaths
              id={ s.innerSectionID }
              text={ s.text }
              fontSize={ dim.svgFontSize }
              key={ `section${i}` }
              points={ s.points }
              onClick={ onSectionClick }
              isSelected={ this.isSelected(s.innerSectionID) }
              isAvailable={ s.nbrOfFreeSeat > 0 }
            />,
          ) }
          { sections.length <= maxSectionsWithText ? sections.map((s, i) => 
            <SectionText
              key={ `section${i}` }
              id={ s.innerSectionID }
              points={ s.points }
              onClick={ onSectionClick }
              text={ s.text }
              fontSize={ dim.svgFontSize }
              isAvailable={ s.nbrOfFreeSeat > 0 }
              width={ svgWidth }
            />,
          ) :  sections.filter(s => s.text.toLowerCase() === 'scen').map((s, i) => 
            <SectionText
              key={ `section${i}` }
              id={ s.innerSectionID }
              points={ s.points }
              onClick={ onSectionClick }
              text={ s.text }
              fontSize={ dim.svgFontSize }
              isAvailable={ s.nbrOfFreeSeat > 0 }
              width={ svgWidth }
            />,
          ) }
        </svg>
      </>
    );
  }

};

export default SectionOverview;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/SectionOverview/SectionOverview.tsx